module.exports = __webpack_public_path__ + "img/home3.fbce5016.png";